import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const projectTasksCountQuery = gql`
  query projectTasksCountQuery($projectId: String) {
    project(projectId: $projectId) {
      id
      tasksCount
    }
  }
`;

export const useProjectTasksCount = ({ projectId, skip } = {}) => {
  const { data, loading } = useQuery(projectTasksCountQuery, {
    variables: { projectId },
    skip,
    fetchPolicy: 'cache-and-network'
  });

  return {
    tasksCount: data?.project?.tasksCount ?? 0,
    loading
  };
};
